'use client'

import { Container, Divider, Dialog, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useSession } from '@marketplace-web/shared/session-data'
import {
  AddressEntryType,
  AddressFieldConfiguration,
  AddressModel,
} from '@marketplace-web/address/address-data'

import UserAddress from '../UserAddress'

type Props = {
  isVisible: boolean
  configuration?: Array<AddressFieldConfiguration>
  address: AddressModel | null
  transactionId?: number
  shippingOrderId?: number | null
  onSubmit: () => void
  onClose: () => void
}

const AddressModal = ({
  isVisible,
  configuration,
  address,
  transactionId,
  shippingOrderId,
  onClose,
  onSubmit,
}: Props) => {
  const userRealName = useSession().user?.real_name

  const translate = useTranslate('profile_shipping_settings.address_settings')

  const addressWithDefaults = {
    ...address,
    name: address?.name || userRealName,
  }

  const handleSubmit = () => {
    onSubmit()
  }

  const handleCancel = () => {
    onClose()
  }

  const getTranslations = () => ({
    buttons: {
      continue: translate('buttons.continue'),
    },
  })

  const renderTitle = () => (
    <Container>
      <Text
        as="h2"
        text={translate('title')}
        type={Text.Type.Title}
        alignment={Text.Alignment.Center}
        width={Text.Width.Parent}
      />
    </Container>
  )

  return (
    <Dialog show={isVisible} hasScrollableContent testId="address-modal">
      <div className="u-overflow-auto u-fill-width">
        {renderTitle()}
        <Divider />
        <UserAddress
          address={addressWithDefaults}
          transactionId={transactionId}
          translations={getTranslations()}
          fieldConfiguration={configuration}
          shippingOrderId={shippingOrderId}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          addressEntryType={AddressEntryType.Shipping}
        />
      </div>
    </Dialog>
  )
}

export default AddressModal
